import {
  Box,
  Flex,
  /*, Icon, Tooltip*/
} from '@chakra-ui/react'
import React from 'react'
// import IconAlwaysOnTop from '~/assets/svgs/icon-always-on-top.svg?react'
import { useSettingsState } from '~/atoms/SettingsState'
import { NotificationBadgeVariant } from '~/components/shared/componentStyles/NotificationBadge.style'
import { NotificationBadge } from '~/components/shared/NotificationBadge'
import { Size } from '~/types/ThemeTypes'
import { isElectron } from '~/utils/common'

// import { useIsAlwaysOnTop } from '~/hooks/useElectronWindow'
import { AccountButton } from './AccountButton'
import { ActionsButton } from './ActionsButton'
import { useTopNavStyle } from './componentStyles'
import { DoNotDisturbSplitButton } from './DoNotDisturbSplitButton'
import { EnvironmentLabel } from './EnvironmentLabel'
import { QueueControlButton } from './QueueControlButton'

export const TopNav = () => {
  const {
    settings: {
      callCenter: { isEnabled: queueEnabled },
      webPhone: { isEnabled: webPhoneEnabled },
    },
  } = useSettingsState()
  const styles = useTopNavStyle()
  // const isAlwaysOnTop = useIsAlwaysOnTop()

  return (
    <Flex sx={styles.banner}>
      <Flex alignItems={'center'}>
        <Box sx={styles.logo} />
        {isElectron && (
          <NotificationBadge
            count={'Beta'}
            size={Size.md}
            variant={NotificationBadgeVariant.Beta}
            sx={{
              paddingLeft: '.5rem',
            }}
          />
        )}
      </Flex>
      <EnvironmentLabel />
      <Flex sx={styles.rightButtons}>
        {/*{isAlwaysOnTop && (*/}
        {/*  <Tooltip label="Always On Top is active (Ctrl-T)">*/}
        {/*    <Flex alignItems={'center'}>*/}
        {/*      <Icon*/}
        {/*        as={IconAlwaysOnTop}*/}
        {/*        boxSize="1.25rem"*/}
        {/*        fill={'mango.teal'}*/}
        {/*      />*/}
        {/*    </Flex>*/}
        {/*  </Tooltip>*/}
        {/*)}*/}
        <ActionsButton />
        {!queueEnabled && <DoNotDisturbSplitButton />}
        {queueEnabled && webPhoneEnabled && <QueueControlButton />}
        <AccountButton />
      </Flex>
    </Flex>
  )
}
